/** Публичный каталог статей с последовательной подгрузкой при прокрутке. */
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

export const BlogPage = () => {
	const {
		data: articles,
		hasMore,
		isLoadingMore,
		isPending,
		loadMore,
	} = apiHooks.blog.useListBlogArticles();
	const sentinelRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const sentinel = sentinelRef.current;
		if (sentinel === null || !hasMore || isLoadingMore) return;
		const observer = new IntersectionObserver((entries) => {
			if (entries[0]?.isIntersecting) void loadMore();
		});
		observer.observe(sentinel);
		return () => observer.disconnect();
	}, [hasMore, isLoadingMore, loadMore]);

	return (
		<main className="flex-1 overflow-y-auto bg-bg px-5 py-8">
			<div className="mx-auto max-w-5xl">
				<div className="mb-8 max-w-2xl">
					<h1 className="text-2xl font-semibold">Блог о планировании ремонта</h1>
					<UIKit.Text className="mt-2 text-ink">
						Практические инструкции по планировке помещений, электрике и подготовке к ремонту.
					</UIKit.Text>
				</div>
				{isPending ? (
					<UIKit.Text className="text-ink">Загружаем статьи...</UIKit.Text>
				) : articles.length === 0 ? (
					<UIKit.Text className="text-ink">Статьи скоро появятся.</UIKit.Text>
				) : (
					<>
						<div className="grid gap-4 md:grid-cols-2">
							{articles.map((article) => (
								<article key={article.id} className="border border-border bg-surface p-6">
									<UIKit.Text size="small" className="text-ink">
										{new Date(article.createdAt).toLocaleDateString("ru-RU")}
									</UIKit.Text>
									<UIKit.Text size="large" className="mt-3 text-lg">
										{article.title}
									</UIKit.Text>
									<UIKit.Text className="mt-3 text-ink">{article.excerpt}</UIKit.Text>
									<Link
										className="mt-5 inline-block text-sm font-medium text-accent hover:underline"
										to={routerPaths.blogArticleUrl(article.slug, article.id)}
									>
										Читать статью
									</Link>
								</article>
							))}
						</div>
						<div ref={sentinelRef} className="h-8" />
						{isLoadingMore && (
							<UIKit.Text className="mt-4 text-center text-ink">Загружаем ещё...</UIKit.Text>
						)}
					</>
				)}
			</div>
		</main>
	);
};
